import { ARCHIVED_RFQS } from "../endpoints";
import api from "../api";

export default {
    store() {
        let url = new URL(ARCHIVED_RFQS);

        return api.post(url);
    }
}